/* eslint-disable no-console */
import { createSelector } from 'reselect'
import { initialState } from './reducer'

const selectPayment = (state) => state.getPayment || initialState

const makeSelectPayment = () => createSelector(
  selectPayment,
  (state) => state
)

export {
  selectPayment,
  makeSelectPayment
}
